var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-table",
    {
      staticClass: "table",
      attrs: {
        multiple: _vm.multiple,
        "no-data-text": "No tienes carga de combustible",
        data: _vm.loadsGasoline
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(ref) {
            var data = ref.data
            return _vm._l(data, function(tr, indextr) {
              return _c(
                "vs-tr",
                { key: indextr, attrs: { data: tr } },
                [
                  _c("vs-td", { attrs: { data: data[indextr].liters } }, [
                    _vm._v(" " + _vm._s(tr.liters) + " ")
                  ]),
                  _c("vs-td", { attrs: { data: data[indextr].invoice } }, [
                    _vm._v(" " + _vm._s(tr.invoice) + " ")
                  ]),
                  _c("vs-td", { attrs: { data: data[indextr].amount } }, [
                    _vm._v(" " + _vm._s(_vm._f("amount")(tr.amount)) + " ")
                  ]),
                  _c(
                    "vs-td",
                    { attrs: { data: data[indextr].kilometerCharge } },
                    [_vm._v(" " + _vm._s(tr.kilometerCharge) + " ")]
                  ),
                  _c(
                    "vs-td",
                    { attrs: { data: data[indextr].voucher } },
                    [
                      _c("DownloadFile", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: "Descargar",
                            expression: "'Descargar'"
                          }
                        ],
                        staticClass: "pill-info-attach",
                        attrs: { name: tr.voucher.name, path: tr.voucher.path }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            })
          }
        }
      ]),
      model: {
        value: _vm.loadsGasolineSelected,
        callback: function($$v) {
          _vm.loadsGasolineSelected = $$v
        },
        expression: "loadsGasolineSelected"
      }
    },
    [
      _c(
        "template",
        { slot: "thead" },
        [
          _c("vs-th", [_vm._v("Litros")]),
          _c("vs-th", [_vm._v("Vale/Factura")]),
          _c("vs-th", [_vm._v("Monto")]),
          _c("vs-th", [_vm._v("Km Carga")]),
          _c("vs-th", [_vm._v("Voucher")])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }